import { SubmitHandler } from 'react-hook-form';
import { InquirySchemaType } from '../commons/Inquiry';
import { useSendInquiry } from 'hooks/U012/useSendInquiryHooks';
import LoadingModal from 'organisms/LoadingModal';
import { useState } from 'react';
import MessageModal from 'organisms/MessageModal';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { InquiryForm } from './U012/InquiryForm';
import { InquiryConfirmation } from './U012/InquiryConfirm';
import { InquirySuccess } from './U012/InquirySuccess';
import { useAuth } from 'hooks/useAuth';

export function Inquiry() {
  const [sendInquiry, loading] = useSendInquiry();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const { t: tInquiry } = useTranslationWithLang('inquiry');
  const [formData, setFormData] = useState<InquirySchemaType | null>(null);
  const auth = useAuth();
  const onSubmit: SubmitHandler<InquirySchemaType> = async (data) => {
    setShowConfirm(true);
    setFormData(data);
    console.log(data);
  };
  const handleSend = async () => {
    await sendInquiry({
      input: {
        user_id: auth.username,
        inquiry: formData?.inquiry || '',
        inquiryType: formData?.inquiryType || '0',
        firstName: formData?.firstName || '',
        lastName: formData?.lastName || '',
        firstNameKana: formData?.firstNameKana || '',
        lastNameKana: formData?.lastNameKana || '',
        mail: formData?.mail || '',
        phone1: formData?.phoneNumber || '',
      },
      onSuccess: () => {
        setShowConfirm(false);
        setShowSuccess(true);
      },
      onError: (err) => {
        console.error(err);
        setErrorMessage(tInquiry('TU012_015'));
      },
    });
  };

  return (
    <>
      {loading && <LoadingModal />}
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tInquiry('TU012_012')}
          onClose={() => {
            setErrorMessage('');
          }}
        />
      )}
      {/* お問い合わせ入力画面 */}
      {!showConfirm && !showSuccess && <InquiryForm onSubmit={onSubmit} />}

      {/* お問い合わせ確認画面 */}
      {showConfirm && !showSuccess && (
        <InquiryConfirmation
          formData={formData!}
          onBack={() => setShowConfirm(false)}
          onConfirm={handleSend}
        />
      )}
      {/* お問い合わせ完了画面 */}
      {showSuccess && <InquirySuccess />}
    </>
  );
}
